const navigationBarHandler = (element) => {
  element.addEventListener('click', (event) => {
    if (event.target.classList.contains('scroll-nav')) {
      $('html, body').animate({ scrollTop: $(`${event.target.dataset.scroll}`).offset().top - 100 }, 2000 );
    }
  });
};

export default navigationBarHandler;
